<section class="pl-1">
  <section class="row">
    <section class="
        my-Account-Header-Name
        col-md-12 col-sm-12 col-lg-12 col-12 col-xl-12
        text-center
      ">
      <h5>{{'myAcountPandPre.myAcount'| cxTranslate}}</h5>
    </section>
  </section>
  <section class="account-Holder-Info-Div row pb-3 pl-3" *ngIf="accountDetails">
    <section class="location" *ngIf="locationData">
      <span class="d-flex align-items-start"><img [src]="'../../assets/icons/'+baseSiteId+'/location.svg'">
      <h6>{{locationData?.facilityName}}&nbsp;({{locationData?.accountNumber}})</h6>
      </span>
    </section>
   
      <section class="
      w-100
      pt-1
      col-md-12 col-sm-12 col-lg-12 col-12 col-xl-12 d-flex
    "
    >
    <section class="account-Name-Label">
      <label>Name</label>
    </section>
    <section class="name-Of-Account">
      <span>{{fullName}}</span>
    </section>
  </section>
  <section class="
      w-100
      pt-1
      col-md-12 col-sm-12 col-lg-12 col-12 col-xl-12 d-flex
    ">
    <section class="account-Name-Label">
      <label>Phone</label>
    </section>
    <section class="name-Of-Account">
      <span>{{accountDetails?.phone}}</span>
    </section>
  </section>
  <section class="
      w-100
      pt-1
      col-md-12 col-sm-12 col-lg-12 col-12 col-xl-12 d-flex mb-4
    ">
    <section class="account-Name-Label">
      <label>Email</label>
    </section>
    <section class="name-Of-Account">
      <span>{{accountDetails?.email}}</span>
    </section>
  </section>
    
   
  </section>
  <section class="pl-4">
    <div [innerHtml]="cmsContent" (click)="baseSiteId == 'vsh' ? openModal() : $event.preventDefault()"></div>
  </section>
</section>